export default __webpack_public_path__ + "static/media/337.d7399bec.png";